<template>
  <div class="basic_con">
    <Frame title="机构信息">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <avue-form
            ref="form"
            v-model="form"
            :option="option"
            @submit="handleSubmit"
          >
            <template slot="unifiedSocialCreditCodeLabel" slot-scope="{ row }">
              <span>{{
                form.custCategory == 2 ? "统一社会信用代码" : "身份证号码"
              }}</span>
            </template>

            <template slot="zcdz" slot-scope="{ row }">
              <div class="flex_wrapper">
                <el-cascader
                  :options="options"
                  v-model="selectedZcdz"
                  :disabled="editType ? false : true"
                >
                </el-cascader>
                <el-input
                  class="el_input"
                  v-model="form.registeredAddressDetailed"
                  placeholder="请输入详情地址"
                  :disabled="editType ? false : true"
                ></el-input>
              </div>
            </template>
            <template slot="bgdz" slot-scope="{ row }">
              <div class="flex_wrapper">
                <el-cascader
                  :options="options"
                  v-model="selectedBgdz"
                  :disabled="editType ? false : true"
                >
                </el-cascader>
                <el-input
                  class="el_input"
                  v-model="form.officeAddressDetailed"
                  placeholder="请输入详情地址"
                  :disabled="editType ? false : true"
                ></el-input>
              </div>
            </template>
          </avue-form>
          <div class="edit_wrapper">
            <el-button
              v-if="!readOnly"
              :loading="loading"
              size="small"
              :icon="editType ? 'el-icon-s-claim' : 'el-icon-edit'"
              :type="editType ? 'primary' : ''"
              @click="editType ? submit() : handleEdit()"
              >{{ editType ? "保存" : "修改" }}</el-button
            >
          </div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import { organInformationConfig } from "./config";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
import * as api from "@/api/factoring/factoringCustomer";
export default {
  name: "organInformation",
  components: {
    Frame,
  },

  data() {
    return {
      form: {},
      editType: false,
      option: organInformationConfig(),
      options: regionData,
      selectedZcdz: [],
      selectedBgdz: [],
      loading: false,
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dataInfo: {
      immediate: true,
      handler(newName, oldName) {
        this.form = newName;

        if (this.form.registeredAddress) {
          let registeredAddressList = this.form.registeredAddress.split(",");

          this.selectedZcdz = [
            TextToCode[registeredAddressList[0]].code,
            TextToCode[registeredAddressList[0]][registeredAddressList[1]].code,
            TextToCode[registeredAddressList[0]][registeredAddressList[1]][
              registeredAddressList[2]
            ].code,
          ];

          this.form.registeredAddressDetailed = registeredAddressList[3];
        }
        if (this.form.officeAddress) {
          let officeAddressList = this.form.officeAddress.split(",");
          this.selectedBgdz = [
            TextToCode[officeAddressList[0]].code,
            TextToCode[officeAddressList[0]][officeAddressList[1]].code,
            TextToCode[officeAddressList[0]][officeAddressList[1]][
              officeAddressList[2]
            ].code,
          ];

          this.form.officeAddressDetailed = officeAddressList[3];
        }
        this.form.industry = Array.isArray(this.form.industry)
          ? this.form.industry
          : this.form.industry.split(",");
      },
    },
  },
  mounted() {},
  methods: {
    // handleChangeZcdz(value) {
    //   console.log(value);
    //   console.log(CodeToText[value[0]]);
    // },
    // handleChangeBgdz(value) {
    //   console.log(value);
    // },

    //修改
    handleEdit() {
      this.loading = true;
      this.$refs.form.option.column.filter((item) => {
        if (
          // item.prop == "custName" ||
          item.prop == "custNo" ||
          item.prop == "unifiedSocialCreditCode" 
          // item.prop == "custCategory"
        ) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      this.editType = true;
      this.loading = false;
    },

    //调用提交方法
    submit() {
      this.$refs.form.submit();
    },
    //提交
    handleSubmit(form, done, loading) {
      let self = this;

      this.$refs.form.validate((vaild) => {
        let registeredAddress = [];
        let officeAddress = [];
        if (this.selectedZcdz.length > 0) {
          this.selectedZcdz.map((item) => {
            registeredAddress.push(CodeToText[item]);
          });
          registeredAddress.push(this.form.registeredAddressDetailed);
        }
        if (this.selectedBgdz.length > 0) {
          this.selectedBgdz.map((item) => {
            officeAddress.push(CodeToText[item]);
          });
          officeAddress.push(this.form.officeAddressDetailed);
        }
        if (vaild) {
          this.loading = true;
          let data = {
            ...this.form,
            registeredAddress: registeredAddress.join(","),
            officeAddress: officeAddress.join(","),
            custAttribute: Array.isArray(this.form.custAttribute)
              ? this.form.custAttribute.join(",")
              : this.form.custAttribute,
            industry: Array.isArray(this.form.industry)?this.form.industry.join(","):this.form.industry,
            id: this.$route.params.id,
          };
          self.editType = false;
          self.loading = false;
          self.$refs.form.option.column.map((item) => {
            item.disabled = true;
          });

          api.submitCustomer(data).then(
            (res) => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              self.editType = false;
              self.loading = false;
              self.$refs.form.option.column.filter((item) => {
                item.disabled = true;
              });
              Object.assign(self.dataInfo, {
                ...res.data.data,
                taxpayerRegisteredAddress: registeredAddress.join(","),
                registeredAddress: registeredAddress.join(","),
              });
              done();
            },
            (error) => {
              // loading();
              window.console.log(error);
            }
          );
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
}
.con_wrapper {
  display: flex;
  // align-items: center;
  padding-right: 20px;
}
.edit_wrapper {
  margin-left: 50px;
  margin-top: -50px;
}
.flex_wrapper {
  display: flex;
  align-items: center;
}
.el_input {
  margin-left: 20px;
}
</style>

